export const SITE_URL = "https://www.ace-gymnastics.com";

export const SITE_NAME = "Ace Gymnastics";

export const DEFAULT_PAGE_TITLE =
  "Ace Gymnastics — Gymnastics Classes in Bardstown, KY";

/** Bump when replacing og-share.jpg so Facebook/Messenger re-fetch the image. */
export const OG_IMAGE_VERSION = "8";

export const DEFAULT_OG_IMAGE = `/og-share.jpg?v=${OG_IMAGE_VERSION}`;

export const DEFAULT_OG_IMAGE_WIDTH = 1200;

export const DEFAULT_OG_IMAGE_HEIGHT = 630;

export const DEFAULT_OG_IMAGE_ALT =
  "Decorative geometric illustration of a gymnast — Ace Gymnastics, Bardstown, KY";

export const SITE_DESCRIPTION =
  "Ace Gymnastics is a family-owned gymnastics facility in Bardstown, Kentucky. Recreational classes, competitive teams, and private lessons for ages 18 months to 18 years.";

/** Facebook App ID for link preview analytics (optional). Set REACT_APP_FB_APP_ID in Netlify. */
export const FB_APP_ID = process.env.REACT_APP_FB_APP_ID?.trim() || "";

export const BUSINESS = {
  name: SITE_NAME,
  telephone: "+1-502-252-8512",
  email: "office@ace-gymnastics.com",
  streetAddress: "2388 New Haven Road",
  addressLocality: "Bardstown",
  addressRegion: "KY",
  postalCode: "40004",
  addressCountry: "US",
  latitude: 37.8092,
  longitude: -85.4669,
  facebook: "https://www.facebook.com/ACE-Gymnastics-101806134601903/",
  instagram: "https://www.instagram.com/ace.gymnastics/",
};

/** Counties within typical drive time for families attending Ace Gymnastics */
export const SERVICE_COUNTIES = [
  "Nelson County",
  "Hardin County",
  "Marion County",
  "Washington County",
  "Larue County",
  "Spencer County",
  "Bullitt County",
];

/** Cities and towns in those counties — used for local SEO structured data */
export const SERVICE_CITIES = [
  // Nelson County
  "Bardstown",
  "Bloomfield",
  "Cox's Creek",
  "New Haven",
  // Hardin County
  "Elizabethtown",
  "Radcliff",
  "Rineyville",
  "Vine Grove",
  "West Point",
  // Marion County
  "Bradfordsville",
  "Lebanon",
  "Loretto",
  // Washington County
  "Springfield",
  "Willisburg",
  // Larue County
  "Hodgenville",
  // Spencer County
  "Taylorsville",
  // Bullitt County
  "Hillview",
  "Lebanon Junction",
  "Mount Washington",
  "Shepherdsville",
];

export const formatPageTitle = (title) => {
  if (/ace gymnastics/i.test(title)) return title;
  return `${title} | ${SITE_NAME} — Bardstown, KY`;
};

export const absoluteUrl = (path = "/") => {
  if (!path) return SITE_URL;
  if (/^https?:\/\//i.test(path)) return path;
  if (String(path).startsWith("//")) return `https:${path}`;
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${SITE_URL}${normalized}`;
};

export const truncateDescription = (text, maxLength = 155) => {
  if (!text) return SITE_DESCRIPTION;
  const cleaned = String(text).replace(/\s+/g, " ").trim();
  if (cleaned.length <= maxLength) return cleaned;
  return `${cleaned.slice(0, maxLength - 1).trim()}…`;
};
